import VueRouter from 'vue-router';
import store from '@/store/store';
import navigationGuardPermissions from '@/services/general/navigationGuardPermissions';
import reinitiliseForceUnlockMenu from '@/services/general/reinitiliseForceUnlockMenu';
import * as types from '@/store/modules/ui-mutation-type';
import routesConfigInterne from '@/router/routesConfigInterne';
import LoginRequired from '@/loginRequired';
import routesAchat from '@/router/routeAchat';
import routesPresse from '@/router/routesPresse';
import routes from './routes';
import routesGabed from './routesGabed';
import routeCompta from './routeCompta';
import routeLogistique from './routeLogistique';
import routesBail from './routesBail';
import routesBonStock from './routeBonStock';

function addExternalRoute(routeToAdd) {
  routeToAdd.forEach((route) => {
    routes[1].children.push(route);
  });
}

// Pour les futurs modules il faut créer le fichier de route l'import et
// appeller la fonction AU DESSUS de addExternalRoute(routesBail) TRES IMPORTANT
// avec en parametre la liste de toutes les routes
// ATTENTION -> l'utilisation du PAGE_DEFAULT ne se fait que dans routeGabed car c'est le
// dernier fichier de routes appelé
addExternalRoute(routesConfigInterne);
addExternalRoute(routesBail);
addExternalRoute(routeLogistique);
addExternalRoute(routeCompta);
addExternalRoute(routesPresse);
addExternalRoute(routesAchat);
addExternalRoute(routesBonStock);
addExternalRoute(routesGabed);

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach(async (to, from, next) => {
  reinitiliseForceUnlockMenu(store);
  if (!LoginRequired(store)) {
    if (to.params?.pathMatch?.startsWith('reinitialisation-mot-de-passe')) {
      next({ name: 'reinitialisationMotDePasse', query: to.query });
      return;
    }
    let site = store.getters['user/site'];
    if (to.query.site) {
      site = to.query.site;
    }

    if (to.path !== '/connexion' && to.path !== '/' && to.path !== '/reinitialisation-mot-de-passe') {
      next({ name: 'connexion', query: { site: site, redirect: to.path } });
    }
  }
  if (await navigationGuardPermissions(to, store) === true) {
    store.commit(`ui/${types.SET_AFFICHE_FOND_NOIR}`, false);
    next();
  }
});

export default router;
